module.exports = __webpack_public_path__ + "img/workTasks.e5e2071d.svg";